export const GET_PATH_REQUEST = "GET_PATH_REQUEST";
export const GET_PATH_SUCCESS = "GET_PATH_SUCCESS";
export const GET_PATH_FAILED = "GET_PATH_FAILED";

export const EXIT_PATH_PREVIEW_REQUEST = "EXIT_PATH_PREVIEW_REQUEST";
export const EXIT_PATH_PREVIEW_SUCCESS = "EXIT_PATH_PREVIEW_SUCCESS";
